import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    locations: [],
    loading: false,
};
export var locations = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
